var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"transform-origin":"center center","width":"40px","height":"40px"},style:({
    transform: _vm.rotated ? 'rotate(45deg)' : '',
    width: (_vm.size + "px"),
    height: (_vm.size + "px"),
  })},[_c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 40 40","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M40 27.7807V40H14.1818H0V0H0.727276H40V12.3238V27.7807Z","fill":"currentCollor"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }